import { cn } from "@/lib/utils"

// A tint of the text colour, not a surface colour: `bg-accent` was the Forge
// raised surface, pure white in the light theme, so a skeleton on a white card
// or the white v8 canvas was invisible. Mixed from currentColor it shows on any
// ground, light, dark or a brand skin, and a caller's own bg- class still wins.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-[color-mix(in_srgb,currentColor_9%,transparent)] animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
